export default {
    data() {
        return {
            basePadding: 25,
            colorPrimary: "#df4545",
            colorInfo: "#383e47",
            // chart
            chartConfig: {
                fontFamily: "Microsoft YaHei",
                // colorList: ["#2c84b5", "#50abad", "#df4545", "#383e47"],
                colorList: ["#2c84b5", "#df4545"],
                colorList2: ["#df4545", "#50abad", "#2c84b5"],
                // screenColorList: ["#5EE4F1", "#FF4D39", "#FFDD17", "#FFFFFF"],
                screenColorList: ["#5EE4F1", "#FF4D39"],
                screenColorList2: ["#5EE4F1", "#FF4D39", "#FFDD17"],
                colorListDark: ["#df4545", "#383e47", "#f79292"],
                lineColor: "#dce0e4",
                splitLineColor: "#dcdddd",
                labelColor: "#383e47",
                shadowColor: "rgb(0,0,0,0.08)",
                legendFontColor: "#606266"
            },
            // rate
            rateColors: ["#df4545", "#df4545", "#df4545"],
            rateTextColor: "#df4545",
            // 列表数据标识字段
            key: "id",
            // 当前选中行对象
            currentRow: {},
            // 分页配置
            pageConfig: {
                // 当前页数
                currentPage: 1,
                // 每页显示个数选择器的选项设置
                pageSizes: [10, 20, 50, 100],
                // 每页显示条目个数
                pageSize: 10,
                // 总条目数
                total: 10,
                // 分页变换的回调函数
                pageChangeCallback: () => { }
            },
            messageType: {
                operate: 0,
                add: 1,
                edit: 2,
                delete: 3,
                export: 4
            },
            realMonitorTimer: null,//实时监视连接定时器对象
            isPlayed: false,//是否正在播放报警音频
            realElevatorDataList: [],
        };
    },
    methods: {
        handlePageSizeChange(val) {
            this.pageConfig.currentPage = 1;
            this.pageConfig.pageSize = val;
            this.pageConfig.pageChangeCallback();
        },
        /**
         * 当前页改变事件
         */
        handleCurrentPageChange(val) {
            this.pageConfig.currentPage = val;
            this.pageConfig.pageChangeCallback();
        },
        message(code, msg) {
            if (code == 0) {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: this.$l(msg),
                    type: 'success'
                });
            } else {
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: this.$l(msg),
                    type: 'error'
                });
            }
        },
        errorMessage(type) {
            if (type == undefined) {
                this.message(-1, "查询失败");
            } else if (type == 0) {
                this.message(-1, "操作失败");
            } else if (type == 1) {
                this.message(-1, "新增失败");
            } else if (type == 2) {
                this.message(-1, "编辑失败");
            } else if (type == 3) {
                this.message(-1, "删除失败");
            } else if (type == 4) {
                this.message(-1, "导出失败");
            } else if (type == 5) {
                this.message(-1, "获取失败");
            }
        },
        confirmAlert(fn1, msg, fn2) {
            let content = "你确定要删除吗?";
            if (msg) {
                content = msg;
            }
            this.$confirm(this.$l(content), this.$l('提示')
                , {
                    confirmButtonText: this.$l('确定'),
                    cancelButtonText: this.$l('取消'),
                    type: "warning"
                }).then(fn1).catch(() => {
                    if (!fn2) {
                        console.log("已取消");
                    } else {
                        fn2();
                    }
                });;
        },
        //判断该操作是否有权限
        hasPermission(name) {
            if (this.$store.state.user.roleType == 1) {
                return true;
            }
            let parentName = this.$route.name;
            let permissions = this.$store.state.permissions;
            let permissionArr = permissions.filter(item => parentName == item.name);
            if (permissionArr.length > 0) {
                return (
                    permissions
                        .filter(item => item.parentId == permissionArr[0].permissionId)
                        .filter(item => item.title == name).length == 1
                );
            }
            return false;
        },
        //判断该操作是否有字段权限
        hasFieldPermission(name) {
            if (this.$store.state.user.roleType == 1) {
                return true;
            }
            let routeName = this.$route.name;
            let fieldPermissions = this.$store.state.fieldPermissions;
            let fieldPermissionArr = fieldPermissions.filter(item => item.id.split('#')[0] == routeName).map(item => item.name);
            if (fieldPermissionArr.length > 0) {
                return fieldPermissionArr
                    .filter(fieldName => fieldName == name).length == 1;
            }
            return false;
        },
        //判断该操作是否有字段权限
        hasIndexPermission(name) {
            if (this.$store.state.user.roleType == 1) {
                return true;
            }
            const arr = JSON.parse(localStorage.getItem("indexPermissions"));
            return arr ? arr.filter(v => v == name).length == 1 : false;
        },
        //判断该操作是否有字段权限
        hasMonitorFieldPermission(name) {
            if (this.$store.state.user.roleType == 1) {
                return true;
            }
            let fieldPermissions = this.$store.state.fieldPermissions;
            if (name == "other#人流量（人/小时）") {
                return fieldPermissions.filter(item => item.id == "other#变频负荷率" || item.id == "other#梯级速度").length == 2;
            }
            let fieldPermissionArr = fieldPermissions.filter(item => item.id == name);
            return fieldPermissionArr.length > 0;
        },
        //根据路由名称判断是否有权限
        hasPermissionByName(name) {
            if (this.$store.state.user.roleType == 1) {
                return true;
            }
            let permissions = this.$store.state.permissions;
            return permissions.filter(item => name.startsWith(item.name)).length > 0;
        },
        inFullScreen() {
            try {
                var docElm = document.documentElement;
                //W3C
                // if (docElm.requestFullscreen) {
                //     docElm.requestFullscreen();
                // }
                //FireFox
                if (docElm.mozRequestFullScreen) {
                    docElm.mozRequestFullScreen();
                }
                //Chrome等
                else if (docElm.webkitRequestFullScreen) {
                    docElm.webkitRequestFullScreen();
                }
                //IE11
                else if (docElm.msRequestFullscreen) {
                    docElm.msRequestFullscreen();
                }
            } catch (e) {
                console.log(e);
            }
        },
        outFullScreen() {
            try {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } catch (e) {
                console.log(e);
            }
        },
        checkFull() {
            //判断浏览器是否处于全屏状态 （需要考虑兼容问题）
            //火狐浏览器
            var isFull = document.mozFullScreen ||
                document.fullScreen ||
                //谷歌浏览器及Webkit内核浏览器
                document.webkitIsFullScreen ||
                document.webkitRequestFullScreen ||
                document.mozRequestFullScreen ||
                document.msFullscreenEnabled
            if (isFull === undefined) {
                isFull = false
            }
            return isFull;
        },
        copyObject(srcObj) {
            let obj = {};
            for (let key in srcObj) {
                obj[key] = srcObj[key];
            }
            return obj;
        },
        openAlarmPage(endDate) {
            localStorage.setItem(this.$store.state.user.username + "_alarm_date", endDate);
            this.$store.state.notify.close();
            if (this.isPlayed) {
                this.$store.state.alarmAudio.load();
            }
            this.$router.push({
                path: '/manage/alarm'
            });
        },
        alarmTips() {
            const username = this.$store.state.user.username;
            const enabled = localStorage.getItem(username + "_alarm_tips_enabled");
            this.isPlayed = false;
            if (!enabled || enabled == "0") {
                return;
            }
            if (!this.$store.state.alarmTipsTimer) {
                this.$store.state.isStopAlarmTips = false;
            }
            const isStopAlarmTips = this.$store.state.isStopAlarmTips;
            if (isStopAlarmTips) {
                return;
            }
            if (this.$store.state.isCloseAlarmTips) {
                this.$store.state.isCloseAlarmTips = false;
                this.$store.state.alarmTipsTimer = window.setTimeout(() => {
                    let startDate = localStorage.getItem(username + "_alarm_date");
                    if (!startDate || this.$common.getTimeDifferenceInSeconds(new Date(startDate), new Date()) > 1800) {
                        startDate = this.$common.getBeforTimeBySeconds(1800);
                    }
                    const isEnableAlarmAudio = localStorage.getItem(username + "_alarm_tips_enableSpeak");
                    this.$http.get(this.$apiConfig.get_new_alarm_list_url, {
                        params: {
                            startDate: startDate,
                            processType: -1
                        }
                    }).then((response) => {
                        const result = response.data;
                        const len = result.data.length;
                        if (result.code == 0 && len > 0) {
                            if (isEnableAlarmAudio && isEnableAlarmAudio == "1") {
                                this.$store.state.alarmAudio.play();
                                this.isPlayed = true;
                            }
                            const str = `<div class="alarmNote__content">
                                            <i class="alarmNote__icon"></i>
                                            <p>广州市合景地盘 XXX 13G0112233于09:58发生故障停梯
                                            <a>详情 &gt;</a>
                                            </p>
                                        </div> `;
                            const h = this.$createElement;
                            let _this = this;
                            this.$store.state.notify = this.$notify({
                                title: this.$l('有新的电梯报警信息'),
                                dangerouslyUseHTMLString: true,
                                message: h('div', {
                                    attrs: {
                                        class: 'alarmNote__content'
                                    }
                                }, [
                                    h('i', {
                                        attrs: {
                                            class: 'alarmNote__icon'
                                        }
                                    }),
                                    h('p', null, [
                                        this.$l('有') + len + this.$l('台电梯发生故障'),
                                        h('a', {
                                            on: {
                                                click: this.openAlarmPage.bind(this, _this.$common.formatCurrentDateTime())
                                            },
                                            style: {
                                                cursor: 'pointer',
                                            }
                                        }, this.$l('详情') + ' >')
                                    ])
                                ]),
                                position: "bottom-right",
                                customClass: "alarmNote",
                                duration: 0,
                                onClose() {
                                    _this.$store.state.isCloseAlarmTips = true;
                                    if (_this.isPlayed) {
                                        _this.$store.state.alarmAudio.load();
                                    }
                                    _this.alarmTips();
                                }
                            });
                        } else {
                            this.$store.state.isCloseAlarmTips = true;
                            this.alarmTips();
                        }
                        if (result.code == 502) {
                            this.message(1, result.msg);
                        }
                    }).catch((error) => {
                        this.$sentry.captureException(error);
                        this.$store.state.isCloseAlarmTips = true;
                        if (this.isPlayed) {
                            this.$store.state.alarmAudio.load();
                        }
                        this.alarmTips();
                    });
                }, window.config.alarmTipsTimerInterval);
            }
        },
        alarmAudioTips() {
            const enabled = localStorage.getItem(this.$store.state.user.username + "_alarm_tips_enableSpeak");
            if (enabled == undefined || enabled == "undefined" || enabled == "0") {
                return;
            }
            if (this.$store.state.alarmAudioTimer != null) {
                return;
            }
            const url = "https://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=3&text=";
            //encodeURI('北大资源10幢西7-DT2 2020-08-09 17:29:45 遥监检修')
            this.$store.state.alarmAudioTimer = window.setTimeout(() => {
                let startDate = localStorage.getItem(this.$store.state.user.username + "_alarm_date");
                if (!startDate || this.$common.getTimeDifferenceInSeconds(new Date(startDate), new Date()) > 1800) {
                    startDate = this.$common.getBeforTimeBySeconds(1800);
                }
                this.$http.get(this.$apiConfig.get_new_alarm_list_url, {
                    params: {
                        startDate: startDate,
                        processType: -1
                    }
                }).then((response) => {
                    const result = response.data;
                    if (result.code == 0) {
                        let data = result.data;
                        let number = localStorage.getItem(this.$store.state.user.username + "_alarm_speak_play_number");
                        const count = number ? parseInt(number) : 1;
                        let msg = "";
                        for (var i = 0; i < data.length; i++) {
                            if (i + 1 > count) {
                                break;
                            }
                            let obj = data[i];
                            let alarmDate = "";
                            let arr = obj.alarmDate.split(" ");
                            let dates = arr[0].split("-");
                            let times = arr[1].split(":");
                            alarmDate = dates[0] + this.$l("年") + dates[1] + this.$l('月')
                                + dates[2] + this.$l('号')
                                ;
                            alarmDate += " " + times[0] + this.$l('点')
                                + times[1] + this.$l('分')
                                + times[2] + this.$l('秒')
                                ;
                            msg += (obj.domainName == null ? "" : obj.domainName) +
                                (obj.buildingName == null ? "" : obj.buildingName) +
                                (obj.elevatorNum == null ? "" : obj.elevatorNum) +
                                ',' + alarmDate + this.$l('发生')
                                +
                                (obj.description == null ? "" : obj.description) + "\r\n";
                        }
                        if (msg.length > 0) {
                            this.$store.state.audioUrl = url + encodeURI(msg);
                            this.$nextTick(() => {
                                this.$store.state.alarmAudio.addEventListener("ended", () => {
                                    this.$store.state.alarmAudioTimer = null;
                                    this.alarmAudioTips();
                                });
                                try {
                                    this.$store.state.alarmAudio.play();
                                } catch (DOMException) {
                                    this.$store.state.alarmAudioTimer = null;
                                    this.alarmAudioTips();
                                }
                            });
                        }
                    }

                    if (result.code == 502) {
                        this.message(1, result.msg);
                    }
                }).catch((error) => {
                    this.$sentry.captureException(error);
                    this.$store.state.alarmAudioTimer = null;
                    this.alarmAudioTips();
                });
            }, wondow.config.alarmAudioTipsTimerInterval);
        },
        logRecord(operateModule) {
            this.$http.post(this.$apiConfig.save_log_url,
                {
                    operateModule: operateModule,
                }).then((response) => {

                }).catch(e => {
                    this.$sentry.captureException(error);
                });
        },
        /* 实时监视 */
        realMonitor(datas, isReSend, fn) {
            const jsonStr = JSON.stringify(datas);
            let realElevatorDataList = JSON.parse(jsonStr);
            const jobNumStr = realElevatorDataList
                .map((t) => t.jobNum)
                .join(",");
            let ws = this.$store.state.ws;
            if (!ws) {
                const token = localStorage.getItem("token");
                ws = new WebSocket(this.$apiConfig.ws_url + "?token=" + token);
                this.$store.commit("setWS", ws);
                ws.onopen = (evt) => {
                    ws.send("structure:" + jobNumStr);
                    ws.send("lift:" + jobNumStr);
                    if (!this.$store.state.user.monitor) {
                        this.realMonitorTimer = window.setTimeout(() => {
                            this.realMonitorTimer = null;
                            if (this.$store.state.ws) {
                                this.$store.state.isAutoCloseWS = false;
                                this.$store.state.ws.close();
                            }
                        }, window.config.monitorConnectCloseTimerInterval);
                    }
                };
            } else {
                if (realElevatorDataList.filter(t => t.data == null).length > 0 || isReSend) {
                    ws.send("structure:" + jobNumStr);
                }
                ws.send("lift:" + jobNumStr);
            }
            if (!isReSend) {
                ws.onmessage = (evt) => {
                    const data = evt.data;
                    if (data.indexOf("Id") > 0 || data.indexOf("Elevator") > 0) {
                        let obj = JSON.parse(data);
                        if (obj.hasOwnProperty("Id")) {
                            for (let i = 0; i < realElevatorDataList.length; i++) {
                                let elevatorObj = realElevatorDataList[i];
                                if (elevatorObj.jobNum == obj.elevatorId) {
                                    elevatorObj.id = obj.Id;
                                    elevatorObj.data = {};
                                    for (const key in obj) {
                                        if (
                                            key == "RunStatus" ||
                                            key == "DeviceStatus" ||
                                            key == "FaultStatus" ||
                                            key == "OtherStatus" ||
                                            key == "VideoStatus" ||
                                            key == "DiagnosisStatus"
                                        ) {
                                            elevatorObj.data[key] = [];
                                            obj[key].split(",").forEach((item, index) => {
                                                elevatorObj.data[key][index] = {
                                                    name: item.trim(),
                                                    value: null,
                                                };
                                            });
                                        }
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < realElevatorDataList.length; i++) {
                                let elevatorObj = realElevatorDataList[i];
                                if (elevatorObj.id == obj.Elevator) {
                                    for (const key in obj) {
                                        if (obj["OnlineTime"].indexOf("0001/1/1") == 0) {
                                            break;
                                        }
                                        if (
                                            key == "RunStatuses" ||
                                            key == "DeviceStatuses" ||
                                            key == "FaultStatuses" ||
                                            key == "OtherStatuses" ||
                                            key == "VideoStatuses" ||
                                            key == "DiagnosisStatuses"
                                        ) {
                                            const aliasKey = key.substring(0, key.length - 2);
                                            const arr =
                                                key == "OtherStatuses"
                                                    ? obj[key].split(",")
                                                    : obj[key].split("");
                                            for (
                                                let j = 0;
                                                j < elevatorObj.data[aliasKey].length;
                                                j++
                                            ) {
                                                let itemArr = elevatorObj.data[aliasKey][j];
                                                itemArr.value = arr[j];
                                            }
                                        } else {
                                            elevatorObj[key] = obj[key];
                                        }
                                    }
                                }
                            }
                            this.setDoorState(realElevatorDataList);
                        }
                        if (fn) {
                            for (let i = 0; i < realElevatorDataList.length; i++) {
                                let realElevatorData = realElevatorDataList[i];
                                if (realElevatorData.energy) {
                                    // realElevatorData.data.ThresholdVoltage = parseInt(Math.random() * 100);
                                    // realElevatorData.data.ActualVoltage = parseInt(Math.random() * 100);
                                    // realElevatorData.data.OutputCurrent = parseInt(Math.random() * 100);
                                    // realElevatorData.data.PowerSaving = parseInt(Math.random() * 100);
                                    if (realElevatorData.data && realElevatorData.data.OtherStatus) {
                                        let index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "阈值电压");
                                        if (index >= 0 && realElevatorData.data.hasOwnProperty('ThresholdVoltage')) {
                                            realElevatorData.data.OtherStatus[index].value = realElevatorData.data.ThresholdVoltage;
                                        } else if (realElevatorData.data.hasOwnProperty('ThresholdVoltage')) {
                                            realElevatorData.data.OtherStatus.push({ "name": "阈值电压", "value": realElevatorData.data.ThresholdVoltage });
                                        }
                                        index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "实际电压");
                                        if (index >= 0 && realElevatorData.data.hasOwnProperty('ActualVoltage')) {
                                            realElevatorData.data.OtherStatus[index].value = realElevatorData.data.ActualVoltage;
                                        } else if (realElevatorData.data.hasOwnProperty('ActualVoltage')) {
                                            realElevatorData.data.OtherStatus.push({ "name": "实际电压", "value": realElevatorData.data.ActualVoltage });
                                        }
                                        index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "输出电流");
                                        if (index >= 0 && realElevatorData.data.hasOwnProperty('OutputCurrent')) {
                                            realElevatorData.data.OtherStatus[index].value = realElevatorData.data.OutputCurrent;
                                        } else if (realElevatorData.data.hasOwnProperty('OutputCurrent')) {
                                            realElevatorData.data.OtherStatus.push({ "name": "输出电流", "value": realElevatorData.data.OutputCurrent });
                                        }
                                        index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "累计节电量");
                                        if (index >= 0 && realElevatorData.data.hasOwnProperty('PowerSaving')) {
                                            realElevatorData.data.OtherStatus[index].value = realElevatorData.data.PowerSaving;
                                        } else if (realElevatorData.data.hasOwnProperty('PowerSaving')) {
                                            realElevatorData.data.OtherStatus.push({ "name": "累计节电量", "value": realElevatorData.data.PowerSaving });
                                        }
                                    }
                                }
                            }
                            if (realElevatorDataList.length == 1) {
                                let realElevatorData = realElevatorDataList[0];
                                if (realElevatorData.elevatorType == '扶梯') {
                                    let vfLoadRate = -1;
                                    let stepSpeed = -1;
                                    let index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "变频负荷率");
                                    if (index >= 0) {
                                        vfLoadRate = realElevatorData.data.OtherStatus[index].value;
                                    }
                                    index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "梯级速度");
                                    if (index >= 0) {
                                        stepSpeed = realElevatorData.data.OtherStatus[index].value;
                                    }
                                    index = realElevatorData.data.OtherStatus.findIndex(t => t.name === "人流量（人/小时）");
                                    if (index >= 0) {
                                        realElevatorData.data.OtherStatus.splice(index, 1);
                                    }
                                    if (vfLoadRate != -1 && stepSpeed != -1 && vfLoadRate != null && stepSpeed != null) {
                                        realElevatorData.data.OtherStatus.push({ "name": "人流量（人/小时）", "value": Math.floor(parseFloat(vfLoadRate.replace('%', '')) / 100 * parseFloat(stepSpeed) * 0.4104 * 2 * 60) });
                                    }
                                }
                            }
                            fn(JSON.stringify(realElevatorDataList));
                        }
                    }
                };
                //监听连接关闭
                ws.onclose = (evt) => {
                    console.log("ws close");
                    if (this.realMonitorTimer) {
                        window.clearTimeout(this.realMonitorTimer);
                        this.realMonitorTimer = null;
                    }
                    if (this.$store.state.isAutoCloseWS && this.$store.state.user.monitor) {
                        this.$store.commit("setWS", null);
                        this.realMonitor(datas, isReSend, fn);
                    }
                    this.$store.state.isAutoCloseWS = true;
                };
                ws.onerror = (e) => {
                    console.log("ws error");
                    // if (this.realMonitorTimer) {
                    //     window.clearTimeout(this.realMonitorTimer);
                    //     this.realMonitorTimer = null;
                    // }
                    // if (ws) {
                    //     ws.close();
                    //     this.$store.commit("setWS", null);
                    // }
                };
            }
        },
        /* 设备巡视（大屏）实时监视 */
        realMonitorBigScreen(datas, isReSend, fn) {
            const jsonStr = JSON.stringify(datas);
            this.realElevatorDataList = JSON.parse(jsonStr);
            const jobNumStr = this.realElevatorDataList
                .map((t) => t.jobNum)
                .join(",");
            let ws = this.$store.state.ws;
            if (!ws) {
                const token = localStorage.getItem("token");
                ws = new WebSocket(this.$apiConfig.ws_url + "?token=" + token);
                this.$store.commit("setWS", ws);
                console.log("save ws");
                ws.onopen = (evt) => {
                    ws.send("structure:" + jobNumStr);
                    ws.send("lift:" + jobNumStr);
                    try {
                        if (!this.$store.state.user.monitor) {
                            this.realMonitorTimer = window.setTimeout(() => {
                                this.realMonitorTimer = null;
                                if (this.$store.state.ws) {
                                    this.$store.state.isAutoCloseWS = true;
                                    this.$store.state.ws.close();
                                }
                            }, window.config.monitorConnectCloseTimerInterval);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                };
            } else {
                if (this.realElevatorDataList.filter(t => t.data == null).length > 0 || isReSend) {
                    ws.send("structure:" + jobNumStr);
                }
                ws.send("lift:" + jobNumStr);
            }
            if (!isReSend) {
                ws.onmessage = (evt) => {
                    const data = evt.data;
                    if (data.indexOf("Id") > 0 || data.indexOf("Elevator") > 0) {
                        let obj = JSON.parse(data);
                        if (obj.hasOwnProperty("Id")) {
                            for (let i = 0; i < this.realElevatorDataList.length; i++) {
                                let elevatorObj = this.realElevatorDataList[i];
                                if (elevatorObj.jobNum == obj.elevatorId) {
                                    elevatorObj.id = obj.Id;
                                    elevatorObj.data = {};
                                    elevatorObj.startTime = new Date().getTime();
                                    for (const key in obj) {
                                        if (
                                            key == "RunStatus" ||
                                            key == "DeviceStatus" ||
                                            key == "FaultStatus" ||
                                            key == "OtherStatus" ||
                                            key == "VideoStatus" ||
                                            key == "DiagnosisStatus"
                                        ) {
                                            elevatorObj.data[key] = [];
                                            obj[key].split(",").forEach((item, index) => {
                                                elevatorObj.data[key][index] = {
                                                    name: item.trim(),
                                                    value: null,
                                                };
                                            });
                                        }
                                    }
                                }
                            }
                        } else {
                            for (let i = 0; i < this.realElevatorDataList.length; i++) {
                                let elevatorObj = this.realElevatorDataList[i];
                                if (elevatorObj.id == obj.Elevator) {
                                    elevatorObj.startTime = new Date().getTime();
                                    for (const key in obj) {
                                        if (obj["OnlineTime"].indexOf("0001/1/1") == 0) {
                                            break;
                                        }
                                        if (
                                            key == "RunStatuses" ||
                                            key == "DeviceStatuses" ||
                                            key == "FaultStatuses" ||
                                            key == "OtherStatuses" ||
                                            key == "VideoStatuses" ||
                                            key == "DiagnosisStatuses"
                                        ) {
                                            const aliasKey = key.substring(0, key.length - 2);
                                            const arr =
                                                key == "OtherStatuses"
                                                    ? obj[key].split(",")
                                                    : obj[key].split("");
                                            for (
                                                let j = 0;
                                                j < elevatorObj.data[aliasKey].length;
                                                j++
                                            ) {
                                                let itemArr = elevatorObj.data[aliasKey][j];
                                                itemArr.value = arr[j];
                                            }
                                        } else {
                                            elevatorObj[key] = obj[key];
                                        }
                                    }
                                }
                            }
                            this.setDoorState2(this.realElevatorDataList);
                        }
                        if (fn) {
                            // console.log("realElevatorDataList:",this.realElevatorDataList);
                            fn(JSON.stringify(this.realElevatorDataList));
                        }
                    }
                };
                //监听连接关闭
                ws.onclose = (evt) => {
                    console.log("ws close");
                    if (this.realMonitorTimer) {
                        window.clearTimeout(this.realMonitorTimer);
                        this.realMonitorTimer = null;
                    }
                    if (this.$store.state.isAutoCloseWS && this.$store.state.user.monitor) {
                        this.$store.commit("setWS", null);
                        this.realMonitorBigScreen(datas, isReSend, fn);
                    }
                    this.$store.state.isAutoCloseWS = true;
                };
                ws.onerror = (e) => {
                    console.log("ws error");
                    console.log(e);
                    // if (this.realMonitorTimer) {
                    //     window.clearTimeout(this.realMonitorTimer);
                    //     this.realMonitorTimer = null;
                    // }
                    // if (ws) {
                    //     ws.close();
                    //     this.$store.commit("setWS", null);
                    // }
                    // if (this.$store.state.user.monitor) {
                    //     this.realMonitorBigScreen(datas,isReSend,fn);
                    // }
                };
            }
        },
        setDoorState(realElevatorDataList) {
            realElevatorDataList.forEach((item) => {
                if (item.DoorState == undefined) {
                    item["DoorState"] = '';
                }
                if (item.elevatorType == '直梯') {
                    if (
                        (item.DoorState == "close" || item.DoorState == "") &&
                        item.DoorStatus
                    ) {
                        item.DoorState = "open";
                    } else if (
                        item.DoorState == "open" &&
                        !item.DoorStatus
                    ) {
                        item.DoorState = "close";
                    } else if (item.DoorState == 'close' && !item.DoorStatus) {
                        item.DoorState = '';
                    }
                }
            });
        },
        setDoorState2() {
            this.realElevatorDataList.forEach((item) => {
                if (item.DoorState == undefined || item.DoorState == null) {
                    item.DoorState = '';
                }
                if (item.elevatorType == '直梯') {
                    if (
                        (item.DoorState == "close" || item.DoorState == "") &&
                        item.DoorStatus === true
                    ) {
                        item.DoorState = "open";
                    } else if (
                        item.DoorState == "open" &&
                        item.DoorStatus === false
                    ) {
                        item.DoorState = "close";
                    }
                }
            });
        },
        getSpecialUserInfo() {
            if (window.specialUsers.includes(this.$store.state.user.username)) {
                return {
                    logoUrl: require("@/assets/img/logo3.png"),
                    videoUrl: window.config.baseUrl + "/media/wanyu_lift.mp4",
                    titleBgUrl: require('@/assets/img/largeScreen/largeScreenTitle3.png')
                }
            }
            return null;
        },
    }
};